//CodebaseMap.jsx

import React from "react";

import { Treemap, ResponsiveContainer, Tooltip } from "recharts";


function getColor(risk){

    if (risk >= 80)
        return "#d73027";

    if (risk >= 60)
        return "#fc8d59";

    if (risk >= 30)
        return "#fee08b";

    return "#6fbf4b";
}

function MapTooltip({ active, payload }) {

    if (!active || !payload || !payload.length) {
        return null;
    }

    const item = payload[0].payload;

    return (
        <div
            style={{
                background:"#fff",
                border:"1px solid #ccc",
                padding:"10px"
            }}
        >

            <div>
                <b>{item.name}</b>
            </div>

            <div>
                Module: {item.module}
            </div>

            <div>
                Risk: {item.risk}
            </div>

            <div>
                LOC: {item.loc}
            </div>


            <div>
                Smells:
            </div>

            <ul>
                {
                    item.smells.map(
                        (s,index)=>
                            <li key={index}>{s.description}</li>
                    )
                }
            </ul>

        </div>
    );
}

function CustomContent(props) {

    const {
        x,
        y,
        width,
        height,
        name,
        normalizedRisk
    } = props;

    const risk = normalizedRisk ?? 0;

    return (

        <g>

            <rect
                x={x}
                y={y}
                width={width}
                height={height}
                fill={getColor(risk)}
                stroke="#fff"
            />


            {
                width > 80 &&
                height > 20 &&
                (
                    <text
                        x={x + 5}
                        y={y + 20}
                        fill="#111"
                        stroke="#111"
                        strokeWidth="0"
                        paintOrder="stroke"
                        fontSize="12"
                        fontWeight="600"
                        fontFamily="Arial, sans-serif"
                    >
                        {name}
                    </text>
                )
            }


        </g>
    );
}

export default function CodebaseMap({ files }) {

    const data = files.map(file => ({

        name:
            file.identity?.className || "unknown",

        loc:
            file.metrics?.loc || 1,

        risk:
            file.impactScore || 0,

        module:
            file.module || "unknown",

        smells:
            file.reasons || []

    }));


    const risks = data.map(
        item => item.risk
    );


    const maxRisk = Math.max(
        ...risks
    );


    const minRisk = Math.min(
        ...risks
    );


    function normalizeRisk(value){

        if (maxRisk === minRisk) {

            return 0;

        }


        return ((value - minRisk) / (maxRisk - minRisk)) * 100;

    }

    const normalizedData = data.map(item => ({

        ...item,

        normalizedRisk:
            normalizeRisk(item.risk)

    }));

    //console.log("CODEBASE MAP NORMALIZED:", normalizedData.slice(0, 10));

    return (

        <ResponsiveContainer
            width="100%"
            height={600}
        >

            <Treemap

                data={normalizedData}

                dataKey="loc"

                stroke="#fff"

                content={<CustomContent />}

            >

                <Tooltip
                    content={<MapTooltip />}
                />

            </Treemap>

        </ResponsiveContainer>

    );

}